import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./analytics";

export const AnalyticsPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location);
  }, [location.pathname, location.search, location.hash]);

  return null;
};
